module.exports = __webpack_public_path__ + "static/img/NR.c5d28629.png";